import React, { useState } from 'react';
import { NormalizedCacheObject } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { MockApolloClient } from 'mock-apollo-client';
import { isArray } from 'lodash';

import { BannerState, InfoBanner } from '../../../Errors/InfoBanner';
import { SessionDetails } from '../ScheduleSessionForm/constants';
import ReminderSuccess from '../ReminderModal/ReminderSuccess/ReminderSuccess';
import SendReminder from '../ReminderModal/SendReminder/SendReminder';
import { useSendMemberEmailReminderMutation } from './documents/SendMemberEmailReminder.generated';

export interface Props {
  dataTestid?: string;
  isCanceling: boolean;
  memberClient: ApolloClient<NormalizedCacheObject> | MockApolloClient;
  onCancel: () => void;
  onSuccess: () => void;
  reminderSuccessContent: React.ReactNode;
  sendReminderContent: React.ReactNode;
  sessionDetails: SessionDetails;
}
const ReminderModal: React.FC<Props> = ({
  children,
  dataTestid,
  isCanceling,
  memberClient,
  onCancel,
  onSuccess,
  reminderSuccessContent,
  sendReminderContent,
  sessionDetails,
}) => {
  const [errorMessage, setErrorMessage] = useState('');

  const [sendMemberEmailReminderMutation, { data, error, loading: isSubmitting }] =
    useSendMemberEmailReminderMutation({
      client: memberClient,
      onCompleted: (data) => {
        if (data?.sendMemberEmailReminder?.ok) {
          onSuccess();
        }
      },
      onError: (error) => {
        if (
          error?.graphQLErrors &&
          isArray(error.graphQLErrors) &&
          error.graphQLErrors.length > 0
        ) {
          setErrorMessage(error.graphQLErrors[0].message ?? '');
        }
      },
      variables: {
        coachingVisitUuid: sessionDetails.sessionUuid,
      },
    });

  const isSuccess = !isCanceling && !isSubmitting && !error && data?.sendMemberEmailReminder?.ok;

  return (
    <div className="text-center p-4" data-testid={dataTestid}>
      {!isSuccess && errorMessage.length > 0 && (
        <InfoBanner bannerState={BannerState.Error} message={errorMessage} />
      )}

      {!isSuccess && (
        <SendReminder
          isCanceling={isCanceling}
          isSubmitting={isSubmitting}
          onCancelSession={onCancel}
          onSendReminder={sendMemberEmailReminderMutation}
          sessionDetails={sessionDetails}
        >
          {sendReminderContent}
        </SendReminder>
      )}

      {isSuccess && <ReminderSuccess>{reminderSuccessContent}</ReminderSuccess>}
    </div>
  );
};

export default ReminderModal;
